import { useMemo } from 'react';
import { sanitizeWithConfig } from '../../app/utils/sanitizeConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export const SanitizedHtml = ({
  body,
  WrapperComponent = 'div'
}) => {
  const sanitizedBody = useMemo(() => sanitizeWithConfig(body || ''), [body]);
  return /*#__PURE__*/_jsx(WrapperComponent, {
    dangerouslySetInnerHTML: {
      __html: sanitizedBody
    }
  });
};